import PropTypes from "prop-types";
import React from "react";
import MomentList from "app/components/chapter/MomentList";

export default class RecursiveMomentList extends React.Component {
  render() {
    // return null;
    return (
      <MomentList
        {...this.props}
        ref={(c) => {
          if (this.props.passthruRef) {
            this.props.passthruRef(c);
          }
        }}
      />
    );
  }
}
